<div class="row" *ngIf="actor">
    <div class="col-md-6">
        <img [src]="actor.profile_path | poster" [alt]="actor.name" class="img-thumbnail">
    </div>
    <div class="col-md-6">
        <h1>{{ actor.name }}</h1>
        <div class="row mb-3">
            <div class="col mb-3">
                <small class="text-white-50 movie-genre" *ngFor="let aka of actor.also_known_as">A.K.A.: {{ aka }}</small>
            </div>
        </div>
        <div class="row mb-3" *ngIf="actor.biography != null || actor.biography != ''">
            <h6 class="text-white-50">BIOGRAPHY:</h6>
            <h4>{{ actor.biography }}</h4>
        </div>
        <div class="row mb-3">
            <h6 class="text-white-50">DATE OF BIRTH:</h6>

            <h5 class="">{{ actor.birthday }}</h5>
            <h5>{{ actor.place_of_birth}}</h5>

        </div>
        <div class="row mb-3">
            <div *ngIf="actor.deathday != null">
                <h6 class="text-white-50">DATE OF DEATH:</h6>

                <h5 class="">{{ actor.deathday }}</h5>

            </div>
        </div>
        <div class="row m-5 text-center">
            <div class="col">
                <button class="btn btn-primary" (click)="onRegresar()">BACK</button>
            </div>
        </div>
    </div>
</div>
<div class="container mt-5">
    <h2 class="text-center mb-3">ALSO STARRING IN:</h2>
    <div class="row">
        <div class="col-sm mb-3" *ngFor="let movie of actorMovies">
            <div class="card" style="width: 100%;">
                <img [src]="movie.backdrop_path | poster" [alt]="movie.title" class="img-thumbnail" />
                <!-- <img src="..." class="card-img-top" alt="..."> -->
                <div class="card-body">
                    <h5 class="card-title similar-title" *ngIf=" movie.title != null " (click)="onMovieClick(movie.id)" style="cursor: pointer;">{{ movie.title }}</h5>
                    <p class="card-text text-black-50">{{ movie.overview | slice:0:100 }}</p>
                    <!-- <button (click)="onMovieClick(movie.id)" class="btn btn-primary">go to film</button> -->
                </div>
            </div>
        </div>
    </div>
</div>